import { useEffect, useState } from "react";

const width = {
  no: "w-[3.5rem]",
  jenis: "w-[10rem]",
  count: "w-[8rem]",
  jumlah: "w-[8rem]",
  total: "w-[8rem]",
  persen: "w-[5rem]",
};

const ReportTemplateSummary = (props) => {
  const { list, listRaw, groupNames, groupMap } = props;
  const [rows, setRows] = useState([]);

  const [totalCount, setTotalCount] = useState(0);
  const [totalJumlah, setTotalJumlah] = useState(0);
  const [totalHarga, setTotalHarga] = useState(0);

  // useEffect(() => {
  //   const _rows = [];
  //   let no = 1;
  //   let totalCount = 0;
  //   let totalJumlah = 0;
  //   let totalHarga = 0;
  //   for (let groupName of groupNames) {
  //     const group = groupMap[groupName];
  //     if (group) {
  //       const groupData = group.group_data;

  //       const row = {
  //         no: no++,
  //         nama: groupData.nama,
  //         jenis: `${groupData.jenis_mobil}, ${groupData.tahun}`,
  //         count: group.group_count,
  //         total_liter: group.total_liter,
  //         total_harga: group.total_harga,
  //       };
  //       totalCount += group.group_count;
  //       totalJumlah += group.total_liter;
  //       totalHarga += group.total_harga;
  //       _rows.push(row);
  //     }
  //   }
  //   for (let row of _rows) {
  //     row.persen = ((row.total_harga / totalHarga) * 100).toFixed(2);
  //   }

  //   setRows(_rows);
  //   setTotalJumlah(totalJumlah);
  //   setTotalCount(totalCount);
  //   setTotalHarga(totalHarga);
  // }, [list, listRaw, groupNames, groupMap]);

  return (
    <table>
      {/* <thead>
        <tr className="row-start-start text-sm w-[42.5rem] bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`border-zinc-300 border w-full  px-2 h-full pb-2 pt-3 `}
          >
            SUMMARY LAPORAN
          </td>
        </tr>
        <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`${width.no} row-center-center border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `}
          >
            #
          </td>
          <td
            className={`${width.jenis} border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            JENIS
          </td>

          <td
            className={`${width.count} col-start-end border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            KENDARAAN
          </td>

          <td
            className={`${width.jumlah} col-start-end border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            JUMLAH (LTR)
          </td>

          <td
            className={`${width.total} col-start-end border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            TOTAL HARGA
          </td>

          <td
            className={`${width.persen} col-start-end border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            %HARGA
          </td>
        </tr>
      </thead>
      <tbody>
        {rows &&
          rows.length > 0 &&
          rows.map((el) => {
            return (
              <tr
                key={`summary-${el.no}`}
                className="row-start-start w-full text-sm text-slate-700 !items-stretch"
              >
                <td
                  className={`${width.no} row-center-center border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
                >
                  {el.no}
                </td>
                <td
                  className={`${width.jenis} row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.nama}
                </td>
                <td
                  className={`${width.count} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.count.toLocaleString("id-ID")}
                </td>
                <td
                  className={`${width.jumlah} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.total_liter.toLocaleString("id-ID")}
                </td>
                <td
                  className={`${width.total} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.total_harga.toLocaleString("id-ID")}
                </td>

                <td
                  className={`${width.persen} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.persen}%
                </td>
              </tr>
            );
          })}
      </tbody>
      <tfoot>
        <tr className="row-start-start text-sm w-full bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`row-end-start w-[13.5rem] border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `}
          >
            GRANDTOTAL
          </td>
          <td
            className={`row-end-start ${width.count} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            {totalCount.toLocaleString("id-ID")}
          </td>
          <td
            className={`row-end-start ${width.count} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            {totalJumlah.toLocaleString("id-ID")}
          </td>
          <td
            className={`row-end-start ${width.count} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            {totalHarga.toLocaleString("id-ID")}
          </td>
          <td
            className={`row-end-start ${width.persen} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            100%
          </td>
        </tr>
      </tfoot> */}
    </table>
  );
};

export default ReportTemplateSummary;
